module.exports = __webpack_public_path__ + "static/media/home_jamira.c33d40e6.png";